import React, { useState } from 'react'
import teamService from '../../components/Services/TeamService';

const useTeamName = () => {
    const [teamNameList, setTeamNameList] = useState("");

    const fetchTeamName = async () => {
        try {
            
            const response = await teamService.getTeamName();
            const data = response.data.teams?.map((item) => ({
                value: item.teamId,
                label: item.name,
            }));
            setTeamNameList(data);
        } catch (error) {
            console.error("Error fetching team names:", error);
        }
    }
  return {
    teamNameList,
    setTeamNameList,
    fetchTeamName,
  }
}

export default useTeamName
